<template>
  <div @click="$router.push({name:'menu',params:{menuId:menu.id}})" v-if="menu" class="mc-wrapper">
    <img :src="menu.backgroundURL[0]" alt class="mc-background" />
    <div class="mc-overlay"></div>
    <div class="dropdown-wrapper">
      <Dropdown :options="actions" />
    </div>
    <div class="mc-content">
      <div class="mc-title">{{menu.menu_name}}</div>
      <BIconPencil />
    </div>
    <b-modal @ok="editMenu" :id="menu.id" size="lg" title="Edit Menu">
      <form action>
        <TextInput :rules="'required'" placeholder="Menu Name" v-model="form.menu_name" />
        <TextInput :disabled="true" :rules="'required'" placeholder="Slug" v-model="form.slug" />
        <TextInput  placeholder="Description" v-model="form.description" />
        <FileUpload
          :onfile="fileChange"
          :value="file"
          :isLoading="fileLoading"
          @changed="fileChange($event)"
          label="upload background image"
          fileTypes="PNG up to 5MB"
          :progress="progress"
          :preview="previewURL(menu.backgroundURL,removeItems)"
          :deleteUrl="deleteUrl"
          :deleteFile="deleteFile"
          :max="1"
        />
      </form>
    </b-modal>
  </div>
</template>

<script>
import { BIconPencil } from "bootstrap-vue";
import Dropdown from "../components/Dropdown";
import { Progress } from "@/components";
import FileUpload from "../components/DragDropFileInput";
import TextInput from "./Inputs/TextInput"
export default {
  props: {
    menu: Object
  },
  components: {
    BIconPencil,
    Dropdown,
    [Progress.name]: Progress,
    FileUpload,
    TextInput
  },
  data() {
    return {
      form: {},
      file: [],
      formValues: "",
      removeItems: [],
      fileLoading: false,
      actions: [
        {
          name: "Edit",
          icon: "Edit.svg",
          handler: this.onEdit,
          shouldRender: true,
          type: "Edit"
        },
        {
          name: `Delete`,
          icon: "delete.svg",
          handler: this.deleteMenu,
          shouldRender: true,
          type: "Delete"
        }
      ]
    };
  },
  methods: {
    fileChange(file) {
      const formData = new FormData();
      formData.append("csvUpload", file);
      const formValues = formData;
      this.file = file;
    },
    onEdit(e) {
      this.$bvModal.show(this.menu.id);
    },
    editMenu(bvModalEvt) {
      bvModalEvt.preventDefault();
      const data = {
        form: this.form,
        backgroundURL: this.previewURL(
          this.menu.backgroundURL,
          this.removeItems
        ),
        file: this.file,
        menuId: this.menu.id
      };
      this.$store.dispatch("Menu/editMenu", data).then(() => {
        this.$bvModal.hide(this.menu.id);
        this.file = [];
        this.$store.dispatch("Menu/resetUploads");
      });
    },
    deleteMenu() {
      this.$store.dispatch("Menu/deleteMenu", this.menu.id);
    },
    deleteUrl(item) {
      this.removeItems.push(item);
    },
    deleteFile(index, item) {
      const tempFiles = [...this.file];
      tempFiles.splice(index, 1);
      this.file = [...tempFiles];
    },
    previewURL(items, removeItems) {
      return items.filter(x => !removeItems.includes(x));
    }
  },
  computed: {
    progress() {
      return this.$store.state.Menu.uploadValue;
    }
  },
  watch:{
    'form.menu_name': function(){
      this.form.slug=this.form.menu_name.replace(/ /g,"").toLowerCase()
    }
  },
  mounted() {
    this.form = {
      menu_name: this.menu.menu_name,
      description: this.menu.description,
      backgroundURL: this.menu.backgroundURL
    };
  }
};
</script>

<style>
.mc-wrapper {
  width: 100%;
  height: 200px;
  border-radius: 10px;
  position: relative;
  cursor: pointer;
  background: white;
}

.mc-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
  position: absolute;
  left: 0;
  right: 0;
}

.mc-wrapper .mc-overlay {
  width: 100%;
  border-radius: 10px;
  position: absolute;
  left: 0;
  right: 0;
  z-index: 1;
  height: 100%;
  background: #00000063;
}

.mc-wrapper .mc-content {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: 600;
  font-size: 24px;
}

.mc-wrapper .dropdown-wrapper {
  color: white;
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 3;
}
</style>